<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="title" label="标题" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="发送时间" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
              <el-popconfirm title="确定要删除此用户吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!-- 新增邮件弹窗 -->
      <el-dialog
        title="新增邮件"
        :visible.sync="showSend"
        width="800px"
        @closed="editForm = {}"
        :destroy-on-close="true"
        custom-class="ele-dialog-form"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="82px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入标题" />
          </el-form-item>
          <el-form-item label="接收人" prop="teacherIds">
            <treeselect
              v-model="editForm.teacherIds"
              :options="teacherList"
              :required="true"
              :multiple="true"
              placeholder="请选择教师"
              :defaultExpandLevel="2"
              valueConsistsOf="LEAF_PRIORITY"
              :normalizer="normalizer"
              style="line-height: 20px"
            />
          </el-form-item>
          <el-form-item label="附件:">
            <el-upload
              v-model="editForm.emailFiles"
              ref="uploadEmailFile"
              action=""
              multiple
              :on-change="handleImageUpload"
              :auto-upload="false"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">上传文件不能超过10M</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="详情:" prop="detail">
            <tinymce-editor v-model="editForm.detail" :init="option" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showSend = false">取消</el-button>
          <el-button type="primary" @click="saveMail(2)">保存草稿箱</el-button>
          <el-button type="primary" @click="saveMail(1)">发送邮件</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  // import Qs from 'qs'
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import TinymceEditor from '@/components/TinymceEditor';
  import { getEmailInfo, getFilePath, sendDraftEmail, saveEmail } from '@/config/api';

  export default {
    name: 'Outbox',
    components: { TinymceEditor, Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/email/getSendEmailList',
          where: {
            type: 1,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        editForm: {
          title: '',
          detail: [],
          teacherIds: [],
        },
        editRules: {
          // 表单验证规则
          title: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
          teacherIds: [{ required: true, message: '请选择接收人', trigger: 'change' }],
          detail: [{ required: true, message: '请填写内容', trigger: 'blur' }],
        },
        teacherList: [], //老师数据
        choose: [], // 表格选中数据
        // showDetail: false,  // 是否显示详情弹窗
        showSend: false, //是否显示新增邮件弹窗
        filePath: 'emailFile/', //附件上传时的路径path参数
        imageFilePath: 'emailImageFile/',
        emailFiles: [], //附件列表
        handFiles: [], //上传之前的文件
        fileList: [], //展示文件列表
        draftsFiles: [], //草稿箱编辑时获取的文件
        // emailDetail:{}
        normalizer(node) {
          if (node.children && !node.children.length) {
            delete node.children;
          }
          return {
            id: node.id,
            label: node.name,
            children: node.children,
          };
        },
      };
    },
    computed: {
      option() {
        return {
          menubar: false,
          file_picker_callback: this.file_picker_callback,
          skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' : '/tinymce/skins/ui/oxide',
          content_css:
            this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
          images_upload_handler: (blobInfo, success, error) => {
            let file = blobInfo.blob();
            const formData = new FormData();
            formData.append('multipartFile', file);
            formData.append('path', this.imageFilePath);
            getFilePath(formData).then((res) => {
              if (res.data.resCode == 200) success(res.data.data[0].fileUrl);
              else error(res.data.resMsg);
            });
          },
        };
      },
    },
    methods: {
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].type !== 2) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
      //显示详情
      edit(row) {
        let data = {
          id: row.id,
          type: 1,
        };
        //获取邮件详情
        getEmailInfo(data).then((res) => {
          this.showSend = true;
          if (res.data.resCode == 200) {
            this.editForm.title = res.data.data.title;
            this.editForm.id = row.id;
            setTimeout(() => {
              this.editForm.detail = res.data.data.detail;
            }, 10);
            this.teacherList = this.$util.toTreeData(res.data.data.teachers, 'id', 'parentId');
            this.deleteChildren(this.teacherList);
            this.$util.eachTreeData(this.teacherList, (d) => {
              if (d.checked && (!d.children || !d.children.length)) this.editForm.teacherIds.push(d.id);
            });
            this.draftsFiles = res.data.data.file.map((item) => {
              return Object.assign(
                {},
                {
                  fileName: item.fileName,
                  fileUrl: item.fileUrl,
                  fileType: item.fileType,
                }
              );
            });
            this.fileList = res.data.data.file.map((item) => {
              return Object.assign({}, { name: item.fileName, url: item.fileUrl });
            });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //文件上传之前
      handleImageUpload(file) {
        const fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error('上传文件不能超过10M');
          this.$refs.uploadEmailFile.uploadFiles.pop(); //解决上传文件超过限制时，show-file-list为true时也显示不成功文件的bug
          return false;
        }
        this.handFiles.push(file.raw);
      },
      // 发送邮件
      saveMail(type) {
        let teacherIds = [...new Set(this.editForm.teacherIds)]; //js去重
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            if (this.handFiles.length !== 0) {
              //判断有无附件
              let fileData = new FormData();
              for (var i = 0; i < this.handFiles.length; i++) {
                fileData.append(`multipartFile`, this.handFiles[i]);
              }
              fileData.append('path', this.filePath);
              getFilePath(fileData).then((res) => {
                //先上传文件到阿里云  获取文件地址
                if (res.data.resCode == 200) {
                  this.emailFiles = res.data.data.concat(this.draftsFiles);
                  const loading = this.$loading({ lock: true });
                  let formDataHasFile = new FormData();
                  for (let key in this.editForm) {
                    if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                      formDataHasFile.append(key, this.editForm[key]);
                    }
                  }
                  formDataHasFile.set('teacherIds', teacherIds);
                  formDataHasFile.append('emailFiles', JSON.stringify(this.emailFiles));
                  if (type == 1) {
                    //直接发送
                    sendDraftEmail(formDataHasFile).then((res) => {
                      //再发送文件
                      loading.close();
                      if (res.data.resCode == '200') {
                        this.showSend = false;
                        this.$message({
                          type: 'success',
                          message: res.data.resMsg,
                        });
                        this.emailFiles = [];
                        this.$refs.table.reload();
                      } else {
                        this.$message.error(res.data.resMsg);
                      }
                    });
                  } else {
                    //保存草稿箱
                    saveEmail(formDataHasFile).then((res) => {
                      //再发送文件
                      loading.close();
                      if (res.data.resCode == '200') {
                        this.showSend = false;
                        this.$message({
                          type: 'success',
                          message: '已保存到草稿箱',
                        });
                        this.emailFiles = [];
                        this.$refs.table.reload();
                      } else {
                        this.$message.error(res.data.resMsg);
                      }
                    });
                  }
                } else {
                  this.$message.error('附件上传失败');
                }
              });
            } else {
              const loading = this.$loading({ lock: true });
              let formDataNoFile = new FormData();
              for (let key in this.editForm) {
                if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                  formDataNoFile.append(key, this.editForm[key]);
                }
              }
              formDataNoFile.set('teacherIds', teacherIds);
              formDataNoFile.append('emailFiles', JSON.stringify(this.draftsFiles));
              if (type == 1) {
                //无附件直接发送
                sendDraftEmail(formDataNoFile).then((res) => {
                  loading.close();
                  if (res.data.resCode == '200') {
                    this.showSend = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                    this.emailFiles = [];
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                });
              } else {
                //无附件保存草稿箱
                saveEmail(formDataNoFile).then((res) => {
                  //再发送文件
                  loading.close();
                  if (res.data.resCode == '200') {
                    this.showSend = false;
                    this.$message({ type: 'success', message: '已保存到草稿箱' });
                    this.emailFiles = [];
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                });
              }
            }
          } else {
            return false;
          }
        });
      },
      //删除
      // remove(row) {
      //   if (!row) {  // 批量删除
      //     if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
      //     // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
      //     let ids = this.choose.map(d => d.id);
      //     this.$confirm('确定要删除选中的用户吗?', '提示', {type: 'warning'}).then(() => {
      //       const loading = this.$loading({lock: true});
      //       let formData = new FormData();
      //       formData.append("ids", ids);
      //       formData.append("state", -1);
      //       batchDelSchoolTeacher(formData).then((res) => {
      //         loading.close();
      //         if (res.data.resCode == 200) {
      //           this.$message({type: 'success', message: res.data.resMsg});
      //           this.$refs.table.reload();
      //         } else {
      //           this.$message.error(res.data.resMsg);
      //         }
      //       }).catch(e =>{
      //         loading.close();
      //         this.$message.error(e.message);
      //       })
      //     }).catch(() => 0);
      //   } else {  // 单个删除
      //     // if(this.choose[0].roles[0].administrator == '1') return this.$message.error('不能删除初始管理员');
      //     const loading = this.$loading({lock: true});
      //     let formData = new FormData();
      //     formData.append("id", row.id);
      //     formData.append("state", -1);
      //     delSchoolTeacher(formData).then((res) => {
      //       loading.close();
      //       if (res.data.resCode == 200) {
      //         this.$message({type: 'success', message: res.data.resMsg});
      //         this.$refs.table.reload();
      //       } else {
      //         this.$message.error(res.data.resMsg);
      //       }
      //     }).catch(e =>{
      //       loading.close();
      //       this.$message.error(e.message);
      //     })
      //   }
      // },
    },
  };
</script>

<style scoped>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 262px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
